/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/7      1.0     Second version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Spin,Alert,message,Steps,Button,Checkbox,Input} from 'antd';
import Lang from "@/components/Lang/Lang";
import {isEmpty,isEmptyObject,getIntlYYMMDD,trim } from '@utils/utils';
import FollowUpAction from "../../FollowUp/FollowUp.action"
import "./followStageDrawer.less";
const { TextArea } = Input;
export default class FollowStage extends PureComponent {
    static defaultProps = {
        buyerId:"",
        labelType:"", //1010:新客标签 1020:成交客户标签
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            stepList: [
                {
                    step:["10"],
                    title: Lang({id:"DaiChuBuLianXi",default:"待初步联系"}),
                    status:"wait",
                },
                {
                    step:["20","21"],
                    title: Lang({id:"BaoChiLianXi",default:"保持联系"}),
                    status:"wait",
                },
                {
                    step:["30"],
                    title: Lang({id:"XuanPin",default:"选品"}),
                    status:"wait",
                },
                {
                    step:["40"],
                    title: Lang({id:"XiaDan",default:"下单"}),
                    status:"wait",
                },
                {
                    step:["50","60"],
                    title: Lang({id:"ChengJiao",default:"成交"}),
                    status:"wait",
                },
            ],
            stepListHadOrder:  this.getDictSteps(),
        }
    }
    /*
    * 获取字典步骤
    * essaone_buyer_label_type: [ "10" : "新客", "20" : "成长客户", "30" : "留存客户", 40" : "预流失客户" ,"50"  "已流失客户",]
    * */
    getDictSteps(){
        const dList =__getDictList("essaone_buyer_label_type")||[];
        let list = []
        dList.forEach(item=>list.push({
            step: [item.code],
            title:item.name,
            status: "wait",
        }))
        return list;
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8299
     **/
    getList(){
        const {buyerId,labelType} = this.props;
        if(buyerId&&labelType){
            this.loading(true);
            FollowUpAction.postHttpAction("/service/mg/follower/query-label-track", {
                buyerId: buyerId,
                labelType:labelType
            }).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
        }
    }
    handleRes(res={}){
        const {success,valid,model,models=[]} = res;
        if (success && valid) {
            const { labelType} = this.props;
            if(labelType=="1010"){
                const { stepList=[]} = this.state;
                let showReasonFormId = "";
                models.forEach((sta,inx)=>{
                    const current = stepList.find(stepItem=>stepItem.step.indexOf(sta.evenCode)>=0);
                    const strDesc = sta.trackDesc;
                    let newStr = strDesc.replace(/\n/g, "<br>");
                     newStr = newStr.replace(/\\n/g, "<br />")
                    if(current){
                        if(sta.evenCode=="60"&&(!sta.notTransactedReasonList||sta.notTransactedReasonList.length==0)){
                            showReasonFormId = sta.trackId;
                        }
                        if(sta.isNode===1){
                            current["status"] = "process";
                        }
                        if(sta.isNode===0){
                            current["status"] = "finish";
                        }
                        current["description"] = (<>
                            {sta.trackDesc?<div className={"black66 font_14"} dangerouslySetInnerHTML={{__html: newStr}} />:null}
                            {!isEmpty(sta.nextTrackDays)?<div className={"mt_4 black66 font_14"}>{Lang({id:"ZhuanDaoXiaYiJieDuanJianGNTian",
                                default:`转到下一阶段间隔 ：${sta.nextTrackDays} 天`,
                                params:[sta.nextTrackDays]})} </div>:null}
                            {sta.evenCode=="60"&&sta.notTransactedReasonList&&sta.notTransactedReasonList.length>0? <div className={"waringBox font_14 black89 mt_4"}>
                                <div className={"font_16 lineH_24"}>{Lang({id: 'YuanYin', default: '原因'})}</div>
                                <ul className={"dotUl mt_4"}>
                                    {sta.notTransactedReasonList.map((reason={})=><li>{reason.evenCode=="50"&&reason.remark?(reason.evenName+"："+reason.remark):reason.evenName}</li>)}
                                </ul>
                                <div className={"mt_4 black45 font_12 lineH_18"}>{sta.reasonCreateBy}
                                    <span className={"ml_4"}>{sta.reasonCreateTime?getIntlYYMMDD(sta.reasonCreateTime,"HH:mm:ss"):''}</span>
                                </div>
                            </div>:null}
                        </>)
                    }
                })
                this.setState({
                    item: model,
                    stepList:stepList,
                    showReasonFormId:showReasonFormId,
                })
            }else {
                const { stepListHadOrder=[] } = this.state;
                models.forEach((sta,inx)=>{
                    const current = stepListHadOrder.find(stepItem=>stepItem.step.indexOf(sta.evenCode)>=0);
                    const strDesc = sta.trackDesc;
                    let newStr = strDesc.replace(/\n/g, "<br>");
                    newStr = newStr.replace(/\\n/g, "<br />")
                    if(current){
                        if(sta.isNode===1){
                            current["status"] = "finish";
                        }
                        current["description"] = (<>
                            {sta.trackDesc?<div className={"black66 font_14"} dangerouslySetInnerHTML={{__html: newStr}} />:null}
                            {sta.evenCode=="40"&&!isEmpty(sta.currentNodeDays)?<div className={"mt_4 black66 font_14"}>
                                {Lang({id: 'YiChenShuiNTian', default: `已沉睡 ${sta.currentNodeDays} 天`,params:[sta.currentNodeDays]})}</div>:null}
                            {sta.evenCode=="50"&&!isEmpty(sta.currentNodeDays)?<div className={"mt_4 black66 font_14"}>
                                {Lang({id: 'YiLiuShiNTian', default: `已流失 ${sta.currentNodeDays} 天`,params:[sta.currentNodeDays]})}</div>:null}
                        </>)
                    }
            })
                this.setState({
                    item: model,
                    stepListHadOrder:stepListHadOrder,
                    showReasonFormId:"",
                })
            }
        }else if(res.message){
            message.error(res.message);
        }
        this.loading(false);
    }
    renderSeason(showReasonFormId){
        const { loading=false,saveReasonMap={} } =this.state;
        const dList = __getDictList("essaone_not_transacted_reason_type")||[];
        return (<div className={"waringBox font_14 black89 mb_4 ml_24"}>
            <div className={"font_16 lineH_24"}>{Lang({id: 'YuanYin', default: '原因'})}</div>
            <ul>
                {dList.map(item=><li className={"mt_4 lineH_21"}>
                    <Checkbox value={item.code} onChange={(e)=>this.onChangeCheck(e.target.checked,item.code)}>
                        {item.name}
                    </Checkbox>
                </li>)}
            </ul>
            {saveReasonMap["50"]?<div className={"mt_8"}>
                <TextArea rows={4} onChange={(e)=>this.onChangeCheck(e.target.value,"remark",)}
                          placeholder={Lang({id:"QingShuRu",default:"请输入"})}
                          maxLength={512}
                />
                </div>:null}
            <Button className={"mt_16"} type="primary" onClick={()=>this.postData(showReasonFormId)} loading={loading}>
            <Lang id="BaoCun">保存</Lang>
            </Button>
        </div>)
    }
    onChangeCheck(checkedValue="",code=""){
        const {saveReasonMap={}} = this.state;
        let newObj = {...saveReasonMap};
        if(code=="remark"){
            this.setState({
                sReasonRemark:checkedValue
            })
        }else {
            if(checkedValue){
                newObj[code]=true;
            }else {
                delete newObj[code]
            }
        }
        this.setState({
            saveReasonMap:newObj,
        })
    }
    /*
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8301
    * 未成交原因选填
    * */
     postData(showReasonFormId){
         const {saveReasonMap={},sReasonRemark} = this.state;
         let reasonCodeList = []
        if( isEmptyObject(saveReasonMap)){
            message.warning(Lang({id:"QingXuanZeYuanYin",default:"请选择原因"}));
            return false
        }
        for(let key in saveReasonMap){
            if(saveReasonMap[key])reasonCodeList.push(key);
        }
         let postData ={
             trackId: showReasonFormId,
             reasonCodeList:reasonCodeList,
         }
        if(!isEmpty(sReasonRemark)){ //todo 对接字段
            postData["remark"] =  trim(sReasonRemark);
        }
         this.loading(true);
         FollowUpAction.postHttpAction("/service/mg/follower/save-cancel-order-reason", postData).then((resp)=>this.handleResSubmit(resp.data)).catch(err=>this.handleResSubmit(err));
    }
    /**
     * 提交
     **/
    handleResSubmit(res={}){
        const {success,valid,} = res;
        if (success && valid) {
            message.success(Lang({id:"BaoCunChengGong",default:"保存成功"}));
            this.showTimer =  setTimeout(()=>{
                this.getList();
                if(this.props.successCallBack){
                    this.props.successCallBack()
                }
            },100);
        }else if(res.message){
           message.error(res.message);
        }
        this.loading(false);
    }
    componentWillMount() {
        this.getList();
    }
    componentDidMount() {
        if (this.props.onRef){
            this.props.onRef(this);
        }
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {labelType} = this.props;
        const {loading = false,item={},stepList=[], showReasonFormId = "",stepListHadOrder=[],saveReasonMap,sReasonRemark} = this.state;
        const sCountryUrl =item.abbreviate?require('../../../assets/img/country/'+item.abbreviate + '.png'):"";
        return ( <Spin spinning={loading}>
                <div className={"flex-item-ver-center"}>
                    {item.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                    <span className={"fw_700 font_18 lineH_27"}>{item.buyerCode||"-"}</span>
                </div>
                <div className={"black45 lineH_21"}>{item.buyerName}</div>
                {item.needTransactionDays>=0?<Alert type="warning"
                                                 message={Lang({id:"HaiShengNTianXuYaoDaChengC",
                                                     default:`还剩 ${item.needTransactionDays} 天，需要达成成交。`,
                                                     params:[item.needTransactionDays]})}
                                                 className={"mt_16 waringMsg"} showIcon />:null}
                {item.orderDays>=0?<Alert type="info" message={Lang({id:"CongZhuCeDaoShouDanChengJ",
                                           default:`从注册到首单成交实现，用了 ${item.orderDays} 天`,
                                           params:[item.orderDays]})}
                                       className={"mt_16 infoMsg"} showIcon />:null}
                {item.preLossDays>=0?<Alert type="warning"
                                                 message={Lang({id:"KeHuNTianHouLiuShiQingGenJ",
                                                     default:`客户 ${item.preLossDays} 天后流失，请跟进客户完成交易`,
                                                     params:[item.preLossDays]})}
                                                 className={"mt_16 waringMsg"} showIcon />:null}
                <Steps
                    progressDot
                    direction="vertical"
                    className={"mt_16 followStageSteps"}
                    items={labelType=="1010"?stepList:stepListHadOrder}
                />
                {isEmpty(showReasonFormId)?null:this.renderSeason(showReasonFormId)}
            </Spin>);
    }
}